import React from "react";
import { Helmet } from "react-helmet";
import { PROTECTED_EMAILS, decodeEmail } from "../utils/emailProtection";

function TermsAndConditions() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions » ClubHosty</title>
        <link
          rel="canonical"
          href="https://www.clubhosty.com/terms-and-conditions"
        />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>Terms & Condition</h2>
              <br />
              <center>
                <p>
                  By purchasing services from ClubHosty, you declare that you
                  agree with our terms and conditions. I understood the TOS of
                  ClubHosty, and only you are using our services after that. And
                  no matter how many services I purchase from ClubHosty, I agree
                  with all the terms and conditions provided by the company.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 section-heading">
                <h3>
                  <i className="fas fa-hand-point-right"></i> Customer Agreement
                </h3>

                <p>
                  The terms of service are the same for all the facilities
                  provided by ClubHosty, and all customers must agree to our
                  terms and conditions before using our services.
                </p>
                <p>
                  Also, by signing up for any service (hosting or otherwise)
                  from ClubHosty, you agree to ClubHosty’s terms of service. You
                  also agree to the use of legal and licensed 3rd party
                  software.
                </p>
                <p>
                  ClubHosty has the right to terminate the service of a customer
                  who inappropriately uses the service.
                </p>
              </div>
              <div id="nav-id-3" className="pt-5 section-heading">
                <h3>
                  <i className="fas fa-hand-point-right"></i> Terms of Service
                  for ClubHosty’s Hosting Services
                </h3>
                <p>
                  Below are the terms of service applicable to the following web
                  hosting services- Shared Hosting, VPS(Virtual Private
                  Servers), and Dedicated Servers.
                </p>
              </div>
              <div id="nav-id-3" className="pt-5 section-heading">
                <h3>
                  <i className="fas fa-hand-point-right"></i> FREENOM Domains
                  Not Allowed
                </h3>
                <p>
                  We don’t allow freenom domain on our any hosting. If you still
                  place an order with the freenom domain and use it for spamming
                  purpose. Your account will be suspended immediately and no
                  refunds will be done.
                </p>
              </div>
              <div id="nav-id-3-1" className="pt-5 section-heading">
                <h3>
                  <i className="fas fa-hand-point-right"></i> Anti-Fraud and Discount Abuse Policy
                </h3>
                <p>
                  ClubHosty is committed to maintaining fair pricing and preventing fraudulent activities. 
                  This policy is designed to ensure that promotional offers, discounts, and coupons are used 
                  legitimately and ethically by our customers.
                </p>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Multiple Account Creation Prohibition
                </h5>
                <p>
                  Creating multiple accounts to claim promotional discounts, coupons, or special offers is strictly prohibited 
                  and constitutes fraud. Each customer is entitled to one account and one set of new customer promotional benefits. 
                  ClubHosty reserves the right to refuse service to anyone who attempts to circumvent this policy.
                </p>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> What Constitutes Discount Abuse
                </h5>
                <p>
                  The following activities are considered discount abuse and are strictly prohibited:
                </p>
                <ul>
                  <li>Creating new accounts after canceling a previous account to claim new customer discounts</li>
                  <li>Operating multiple accounts under different names or email addresses to repeatedly claim promotional offers</li>
                  <li>Using false, misleading, or fraudulent information during account registration to obtain discounts</li>
                  <li>Sharing or reselling promotional codes intended for single-use or first-time customers</li>
                  <li>Creating accounts using temporary email services, VPNs, or proxy servers to bypass our fraud detection systems</li>
                  <li>Attempting to manipulate payment information or billing details to claim multiple discounts</li>
                  <li>Using stolen credit cards, payment information, or identity theft to create accounts</li>
                </ul>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Detection and Enforcement
                </h5>
                <p>
                  ClubHosty employs sophisticated fraud detection systems that monitor various parameters including but not limited to:
                </p>
                <ul>
                  <li>IP addresses and geographical locations</li>
                  <li>Payment methods and billing information</li>
                  <li>Email addresses and contact information patterns</li>
                  <li>Device fingerprints and browser information</li>
                  <li>Account usage patterns and behavior analytics</li>
                  <li>Domain registration history and ownership records</li>
                </ul>
                <p>
                  Our automated systems, combined with manual review processes, can identify suspicious patterns 
                  that indicate fraudulent activity or discount abuse.
                </p>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Consequences of Violation
                </h5>
                <p>
                  If ClubHosty determines that an account was created to abuse discounts or promotional offers, 
                  we reserve the right to take the following actions:
                </p>
                <ul>
                  <li><strong>Immediate Order Rejection:</strong> Orders placed using fraudulent methods will be rejected immediately without notice</li>
                  <li><strong>Account Suspension or Termination:</strong> All accounts associated with the violation will be suspended or permanently terminated</li>
                  <li><strong>No Refund Policy:</strong> Accounts found in violation are not eligible for any refunds, including our standard money-back guarantee</li>
                  <li><strong>Service Denial:</strong> We reserve the right to refuse future service to individuals found in violation of this policy</li>
                  <li><strong>Legal Action:</strong> In cases of fraud, identity theft, or payment fraud, ClubHosty may pursue legal action and report the incident to appropriate authorities</li>
                  <li><strong>Blacklisting:</strong> Email addresses, payment information, and other identifiers associated with abuse will be permanently blacklisted</li>
                  <li><strong>Data Sharing:</strong> Information about fraudulent activities may be shared with payment processors, fraud prevention networks, and law enforcement agencies</li>
                </ul>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Legitimate Use of Promotions
                </h5>
                <p>
                  Customers are welcome to use promotional codes and discounts that are:
                </p>
                <ul>
                  <li>Publicly available on our official website or authorized partner channels</li>
                  <li>Applicable to their account type and service category</li>
                  <li>Used in accordance with the specific terms and conditions of each promotion</li>
                  <li>Applied to first-time purchases when specified as "new customer only" offers</li>
                </ul>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Appeal Process
                </h5>
                <p>
                  If you believe your account was flagged in error, you may submit an appeal to our compliance team 
                  at {decodeEmail(PROTECTED_EMAILS.ABUSE)} within 7 days of the action. Include your account details, 
                  order information, and any evidence supporting your claim. All decisions made by ClubHosty's compliance 
                  team are final and binding.
                </p>
                
                <h5 className="pt-3">
                  <i className="fa fa-solid fa-circle" style={{ fontSize: "10px" }}></i> Reporting Abuse
                </h5>
                <p>
                  If you become aware of any discount abuse or fraudulent activities, please report it to {decodeEmail(PROTECTED_EMAILS.ABUSE)}. 
                  We appreciate our customers' help in maintaining a fair and secure environment for everyone.
                </p>
                
                <p className="pt-3">
                  <strong>Note:</strong> ClubHosty reserves the right to modify this Anti-Fraud and Discount Abuse Policy 
                  at any time without prior notice. Continued use of our services constitutes acceptance of any changes to this policy.
                </p>
              </div>
              <div className="section-heading">
                <div id="nav-id-4" className="pt-5 ">
                  <h4>
                    <i className="fas fa-hand-point-right"></i> Shared Web
                    Hosting
                  </h4>
                </div>
                <div id="nav-id-5" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Only selected domain extensions can be registered for free
                    with a minimum of 1-year hosting plans, as mentioned on the
                    website. No premium domain name will be available for free.
                  </p>
                </div>
                <div id="nav-id-6" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Limited Resources on shared hosting packages-</b>{" "}
                    Resources in any shared hosting plans are shared between
                    various users. As per fair usage policy, in any shared
                    hosting plan, the usage of CPU resources by customers is
                    limited to ensure that the performance of other websites is
                    not affected negatively.{" "}
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If at any point in time, there is an over-usage of resources
                    or the resources of the shared server have been exhausted by
                    a customer, the company holds the exclusive right to suspend
                    the customer’s account. The customer will be required to
                    upgrade the plan in order to continue the services .
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>
                      Disallowed website content on a shared server- ClubHosty
                      prohibits hosting any content that may harm the company on
                      the shared servers. As mentioned, the disallowed contents
                      are Warez, adult, gambling, automatic scripts, copyrighted
                      content, etc.
                    </b>
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Disallowed websites include fraudulent sites
                    (phishing/scamming sites), copyrighted sites (including
                    video, audio, image, or written content, etc.), Adult sites
                    (Gambling sites, pornographic sites, sites that enable human
                    trafficking, violence, websites inappropriate of minors,
                    etc), IRC Hosts, Gaming sites.
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Hosting downloadable and streamable content or podcasts is
                    not allowed. Customers can provide links to download/stream
                    their original content hosted anywhere else. The link
                    provided should be of personally owned content and
                    copyrighted. This may lead to the issuing of a copyright
                    notice
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> What is
                    considered downloadable and streamable content?
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Streaming is when a customer hosts media on the server for
                    users to watch directly or on-demand on your website.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Downloading allows users to save the media(videos, movies,
                    audio, songs, etc.) directly from your website.
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Content backups are available only for the previous 7 days
                    and can only be restored for the T+1 or T-1 date. Server
                    backups run for days at times; thus, the backups available
                    of a particular site are of specific dates in the past 7
                    days and can be restored. And thus, if a customer demands a
                    backup of a particular date (T), the company might only be
                    able to provide the backup of the T+1 or T-1 date.
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Email backups are not available with shared hosting.{" "}
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>100 emails per day per account-</b> A customer can send
                    out only 100 emails per day from a single account on shared
                    server hosting plans.{" "}
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Only upgradation of web hosting plans is possible.{" "}
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h4>
                    <i className="fas fa-hand-point-right"></i> VPS
                    (Semi-Managed)
                  </h4>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Unmanaged VPS Hosting with root access will be made
                    instantly available to the customers once the order is
                    completed.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    For semi-managed VPS hosting, the servers will be made
                    available with one-time free installation of the control
                    panel within 4 hours of the completion of the order.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any installation of extra licenses will be chargeable and
                    include the cost of the license.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Support for any third-party or nulled script (including
                    installation) is not available.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Paid offsite backup facility is available with VPS hosting.
                    The backup will be commenced on the customer’s demand and
                    after the release of payment.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any content that will harm the company in any way is
                    strictly prohibited. Hosting such content will lead to the
                    dismissal of service with immediate effect. The disallowed
                    contents are as mentioned- Warez content, adult content,
                    gambling content, copyrighted content, etc. <br />
                    Disallowed websites include: fraudulent sites
                    (phishing/scamming sites), copyrighted sites, Adult sites
                    (Gambling sites, pornographic sites, violence, websites
                    inappropriate of minors, etc)
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If a customer needs more than 8 IPs, then he/she will be
                    required to send a formal email listing the reason and
                    explanation of why he needs more than 8 IPs and where they
                    will use it. A proper written justification has to be sent
                    for verification. And only when the verification is
                    approved, the extra IPs will be assigned.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h4>
                    <i className="fas fa-hand-point-right"></i> Dedicated
                    Servers
                  </h4>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    In dedicated servers only monthly billing is available. For
                    annual or semi-annual billings, a proper contract will be
                    signed on demand.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Unmanaged dedicated servers are delivered to the customer
                    within 4 hours of the completion of the order.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Standard or managed dedicated servers are delivered to the
                    customer within 72 hours of completion of the order.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Customers can choose to install only these Operating Systems
                    on their dedicated servers- CentOS, Ubuntu, and Windows.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Customers will be provided with a single IP. If a customer
                    wants an extra IP, he/she will be required to pay $3 per IP
                    billed monthly.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any individual/company can be assigned a maximum of 8 IPs
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If a customer needs more than 8 IPs, then he/she will be
                    required to send a formal email listing the reason and
                    explanation of why he needs more than 8 IPs and where they
                    will use it. A proper written justification has to be sent
                    for verification. And only when the verification is
                    approved, the extra IPs will be assigned.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Content
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Please go through our Content Policy for complete details on
                    prohibited content and activities.
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <b>1.</b> ClubHosty reserves the right to refuse access to
                    its servers and other services in accordance to its Terms of
                    Policy.{" "}
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <b>2.</b> Customers must use the services provided for
                    lawful purpose only. We prohibit transmission, storage or
                    presentation of data/information/material taht violates any
                    applicable law or regulation.{" "}
                  </p>
                </div>
                <div id="nav-id-7" className="pt-5">
                  <p>
                    <b>3.</b> Mentioned below are the examples of activities and
                    content that is strictly prohibited from use on ClubHosty
                    servers:
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    a. Topsites, ponzy, pyramid schemes, bitcoin/cryptocurrency
                    mining, prime bank programmes, forex, e-gold, bank
                    debentures or bank debenture trading programs, escrow, high
                    yield investment programs, lottery, gambling, warez.
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    b. Proxy, bots, spam bots, port scanners, IP scanners, chat
                    rooms, mail bombers, mail harvesting scripts, brute force
                    scripts, banner rotators, anonymous/bulk SMS gateways.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    c. Use of disk space for secondary storage and dumping files
                    on the servers.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    d. Selling of illegal pharma, drugs, explosives, pirated
                    softwares, illegal downloads and products, galleries/banner
                    exchanges, streaming/broadcasting live copyrighted content,
                    using adult thumbnails.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    e. Phishing materials, malware, ransomware, spyware, etc.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-check-circle"
                      aria-hidden="true"
                      style={{ fontSize: "13px" }}
                    ></i>{" "}
                    f. Promoting illegal content or linkage with any
                    website/platform promoting illegal activities.{" "}
                  </p>
                  <p>
                    <b>4.</b> Hosting content that in any shape or form promotes
                    or advocates human trafficking, prostitution or escort
                    services as determined by ClubHosty is strictly prohibited.
                  </p>
                  <p>
                    <b>5.</b> Promoting/advocating/hosting child pornography or
                    linking to child pornography or exploitation sites will lead
                    to termination of service without notice or warning.{" "}
                  </p>
                  <p>
                    <b>6.</b> Adult Content: It includes embedding or uploading
                    any and all pornographic/adult images, videos, audios or
                    otherwise lewd/obscene content or linking to websites that
                    promotes pornographic/adult images, videos, audios or
                    otherwise lewd/obscene content at ClubHosty’s discretion.{" "}
                  </p>
                  <p>
                    <b>7.</b> Illegal material including copyrighted content,
                    music files, commercial audio/video or any material that
                    violates the laws and regulation or can be perceived as
                    misleading.{" "}
                  </p>
                  <p>
                    <b>8.</b> Warez: includes and not limited to pirates
                    softwares, emulators, ROMS, phreaking, hacking, password
                    cracking, IP spoofing and encrypting any of the above. This
                    also includes linking to or providing information about the
                    same.
                  </p>
                  <p>
                    <b>9.</b> Hosting games of any kind is strictly prohibited
                    on ClubHosty servers and will lead to termination of service
                    with immediate effect.{" "}
                  </p>
                  <p>
                    <b>10.</b> Hosting any content that promotes, relates to or
                    advocates indecent, rude, racist, hate comment or is
                    generally unacceptable at ClubHosty’s discretion is
                    prohibited
                  </p>
                  <p
                    style={{
                      fontStyle: "italic",
                      background: "whitesmoke",
                      padding: "10px",
                    }}
                  >
                    In compliance with DMCA act, ClubHosty has adopted
                    procedures for parties who believe that a hosted site on our
                    service is infringing their copyrights. All copyright
                    complaints must be submitted to {decodeEmail(PROTECTED_EMAILS.ABUSE)}.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Abuse Of
                    Resources
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any attempts to compromise or actual compromise of a network
                    device belonging to ClubHosty or any other company,
                    individual, or other entity is strictly prohibited. This
                    offense also includes port scanning, IP range scanners, and
                    vulnerability scanning. All infractions and or suspected
                    infractions will be vigorously investigated and may result
                    in immediate termination of service.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Denial of Service (DOS) attacks directed at ClubHosty, or
                    any attempts to launch a Denial of Service attack from our
                    servers are strictly prohibited. All infractions and/or
                    suspected infractions will be vigorously investigated and
                    may result in immediate termination of service.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Hosting any software, source code, or any other material
                    that is illegal or could be used to commit an illegal act is
                    strictly prohibited. This includes but is not limited to
                    software exploits; exploits source code, hacking tutorials,
                    hacking tools, viruses and Trojans, bomb-making, and similar
                    device tutorials. All infractions and or suspected
                    infractions will be vigorously investigated and may result
                    in immediate termination of service.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The hosting of material that infringes on any copyright,
                    trademark and or service mark is strictly prohibited. This
                    also includes the storage and transmission of pirated
                    movies, music, software, ringtones or anything else
                    considered "Warez". Any authentic complaint received will be
                    investigated and may result in termination of service.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The hosting of defamatory, scandalous, or private
                    information about a person without their consent,
                    intentionally inflicting emotional distress or violating
                    trademarks, copyrights, or other intellectual property
                    rights is strictly prohibited resulting in termination of
                    service with immediate effect without any refund.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any attempts to undermine or cause harm to any of our
                    servers is strictly prohibited. We hold no responsibility
                    for the use of our clients' accounts. Any account that
                    abuses the resources and actions are not taken to desist the
                    activity, calls for immediate deactivation without any
                    refund.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any site using what we deem to be using excessive CPU cycles
                    or any resources that cause strain to other sites will be
                    suspended and offered the option to upgrade the plan.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Although we offer 99.9% uptime we can not fully guarantee
                    this. This is due to the updates and up-gradation we carry
                    out which is also a part of our maintenance.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If any client is in any way disrespectful towards any member
                    of the ClubHosty staff we have full right to remove them
                    from our services without any refund.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Unsolicited
                    commercial email/Unsolicited bulk e-mail (SPAM)
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Use of our service to transmit any unsolicited commercial or
                    unsolicited bulk e-mail is expressly prohibited. Violation
                    of this SPAM policy will result in severe penalties
                    including suspension or termination of account without
                    refund.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Upon notification of an alleged violation, we will initiate
                    a full-scale investigation during which we may restrict
                    customers' access to the network to prevent further
                    violations.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If a customer is found to have violated our policy, we may,
                    at our sole discretion, restrict, suspend or terminate the
                    guilty hosting account. Furthermore, we reserve the right to
                    pursue civil remedies for any costs associated with the
                    investigation of a substantiated policy violation. We will
                    notify law enforcement officials if the violation is
                    believed to be a criminal offense.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Anyone using our service to host websites or services that
                    support spammers or cause any of our IP space to be listed
                    in any of the various Spam Databases will have their
                    account(s) immediately suspended and an administrative fee
                    of $300.00 will be charged to your account.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The account will remain suspended until such time that you
                    agree to remove any and all traces of the offending material
                    immediately upon reconnection. First violations of this
                    policy will result in a warning and your account will be
                    reviewed for possible immediate termination.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    A second violation may result in an immediate termination of
                    your account and the administrative fees will be $500.
                    Severe violations may result in immediate and permanent
                    removal of the account(s) from our network without notice to
                    the customer.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We have a zero-tolerance policy for the use of our service
                    towards posting of messages or commercial advertisements
                    which violate the rules, regulations, or charter of any
                    newsgroups or mailing list. Commercial messages that are
                    appropriate under the rules of a newsgroup or mailing list
                    or that are solicited by the recipients are permitted.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We also prohibit hosting of publicly accessible "open relay"
                    SMTP or anonymous remailer service for any purpose, cause,
                    or reason whatsoever.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Domain Payments
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Domain Registrations:</b> No refund is applicable once
                    the domain is registered.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Domain infringement:</b> You cannot register a domain
                    name that is similar to a trademarked domain/a domain
                    similar to a brand and is engaged in a business providing
                    similar goods or services.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any person trying to register such a domain name will be
                    held liable for infringement of the Trademark. Example:
                    Flipkartsale.in, bajajfinancecs.com, adtyabrlafnanc.co.in,
                    shopcluessale.in, etc.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Domain Renewal:</b> We will send you reminders to renew
                    your domain one month before the expiry. ClubHosty will not
                    be held responsible for failure or delay in the renewal of a
                    domain. Once a domain is renewed no refunds will be given.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The <b>special offer</b> we have going on <b>Domain</b> is only valid for new domain name registrations, and unfortunately, it doesn’t apply to domain transfers. But don’t worry, we’ve got some amazing deals for registering a brand new domain!
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Reseller Terms
                    and Client Responsibility
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Using a shared hosting account to resell web hosting to
                    others is not allowed. Reseller hosting plans are to be
                    considered if you want to become our reseller.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Resellers must assure that each of their clients follows
                    ClubHosty’s Terms of Service Agreement.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Resellers are completely responsible for supporting their
                    clients including customer service, billing, and technical
                    support. We are not liable to provide support to Reseller
                    Users. Any assistance needed for the client's issue must be
                    reported by the reseller on the user's behalf.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Resellers are solely responsible for any content that is
                    stored or transferred under their reseller account and the
                    actions of their Users. We will hold the reseller
                    responsible for any activity from their client's account
                    that violates the law or this Agreement.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The Company shall not be kept liable for the acts or
                    omissions of our resellers. The reseller hereby promises to
                    indemnify the Company to and against any and all claims
                    brought by any Customer resulting from the actions or
                    omissions of the reseller.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The Company retains the right to review our Reseller plan
                    anytime necessary. Changes shall take place as posted
                    publicly or at any later date as the Company can designate.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Uptime Guarantee
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any service interruptions or downtime due to scheduled
                    maintenance by ClubHosty or our network providers will not
                    count towards the uptime guarantee.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    ClubHosty will not be held liable in any way for the failure
                    of third-party services.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    ClubHosty will not be held liable for failure or delay in
                    performing its obligations if such failure or delay is due
                    to circumstances beyond its reasonable control, including
                    but not limited to acts of any governmental body, war,
                    insurrection, sabotage, embargo, fire, flood, strike or
                    other labor disturbance, interruption of or delay in
                    transportation, unavailability of, interruption or delay in
                    telecommunications or third party services (including DNS
                    propagation), failure of third party software or hardware or
                    inability to obtain raw materials, supplies or power used in
                    or equipment needed for the provision of the Services.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Account Security
                    and Company Systems
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You are responsible for any misuse of your account.
                    Therefore, you must take steps to ensure that others do not
                    gain unauthorized access to your account. In addition, you
                    may not use your account and our services to breach the
                    security of another account or attempt to gain unauthorized
                    access to another network or server.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Your password provides access to your account. It is your
                    responsibility to create a strong password and keep it
                    secure.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Sharing your password and account access with unauthorized
                    users is not recommended. You should take care and prevent
                    others from using your account since you will be responsible
                    for the consequences.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Attempting to obtain another user's account password is
                    strictly prohibited, and will result in termination of
                    service.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You must adopt adequate security measures to prevent or
                    minimize unauthorized use of your account.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You may not attempt to circumvent user authentication or
                    security of any host, network, or account. This includes,
                    but is not limited to, accessing data not intended for you,
                    logging into or making use of a server or account you are
                    not expressly authorized to access, or probing the security
                    of other networks. Use or distribution of tools designed for
                    compromising security is prohibited. Examples of these tools
                    include, but are not limited to, password guessing programs,
                    cracking tools, or network probing tools.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You may not attempt to interfere with service to any user,
                    host, or network ("denial of service attacks"). This
                    includes, but is not limited to, "flooding" of networks,
                    deliberate attempts to overload a service, and attempts to
                    "crash" a host. Users who violate systems or network
                    security may incur criminal or civil liability. ClubHosty
                    will cooperate fully with investigations of violations of
                    systems or network security at other sites, including
                    cooperating with law enforcement authorities in the
                    investigation of suspected criminal violations.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    It is your duty to make sure all the programs/scripts
                    installed under your hosting account are secure and
                    permissions of directories are set properly, regardless of
                    the installation method. When at all possible, set
                    permissions on most directories to 755 or as restrictive as
                    possible. Users are ultimately responsible for all actions
                    taken under their account. This includes the compromise of
                    credentials such as username and password. You are required
                    to use a secure password. If a weak password is used, your
                    account may be suspended until you agree to use a more
                    secure password. Audits may be done to prevent weak
                    passwords from being used. If an audit is performed, and
                    your password is found to be weak, we will notify you and
                    allow time for you to change or update your password before
                    suspending your account.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any account found connecting to a third-party network or
                    system without authorization from the third party is subject
                    to suspension. Access to networks or systems outside of your
                    direct control requires the express written consent of the
                    third party. We may, at our discretion, request
                    documentation to prove that your access to a third-party
                    network or system is authorized.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Any account that is found to be compromised may be disabled
                    and/or terminated. If you do not clean up your account after
                    being notified by us of an ongoing issue, we reserve the
                    right to keep your account disabled. Upon your request, we
                    may clean up your account for an additional fee.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We reserve the right to migrate your account from one data
                    center to another in order to comply with applicable data
                    center policies, local law, or for technical or other
                    reasons without notice.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Cancellation
                    Process
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    At any point in time, you wish to discontinue our services,
                    you can place the cancellation request through your client
                    area. Before that, you need to clear all the pending dues
                    (if any).
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You can either choose immediate cancellation or request
                    cancellation to happen once your subscription period
                    expires. If you select immediate cancellation, you will no
                    longer have access to your hosting plan/service. If
                    cancellation after the tenure period is over is selected,
                    you will continue to have access to use the Services
                    purchased until the end of your prepaid term.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    It is your responsibility to backup all your data before you
                    place the cancellation request. Once you place the
                    cancellation request all your data from our server will be
                    deleted and it cannot be retrieved nor restored.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Taxes
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The prices mentioned on the site are exclusive of taxes. To
                    view the price with taxes please refer to the Cost
                    Calculator of each plan. The amount inclusive of taxes will
                    be added to your final invoice once you add items to your
                    cart. The taxable amount is non-refundable.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Late Payment or
                    Non-Payment
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Unpaid invoices may result in the suspension or termination
                    of your web hosting account. Your suspended account will
                    only be restored after clearing the outstanding invoice
                    after which you will be able to access your data.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If your account gets terminated, the data residing on it
                    won't be restored and will be treated as a new account. If
                    you fail to renew your subscription on time you will be
                    charged on your invoice.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We will not activate new orders or activate new packages for
                    customers who have an outstanding balance on their accounts.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Invoice Disputes
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    For any queries related to cost on your account, do reach
                    out to our billing team at {decodeEmail(PROTECTED_EMAILS.BILLING)}
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-8" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Domain Transfer Restrictions
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Domain transfers are subject to billing status verification. Any domain with a generated invoice (paid or unpaid) cannot be transferred until all billing obligations are satisfied.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    A minimum waiting period of 60 days applies after the last payment before domain transfer requests can be processed. This policy protects against fraudulent activities and ensures billing compliance.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Customers attempting to transfer domains with outstanding invoices will be required to clear all dues before the transfer process can commence.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Account
                    Termination
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Your hosting account at ClubHosty can get terminated due to
                    the following reasons:
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>You decide to discontinue-</b> You decide to discontinue
                    At any point in time, during your subscription, if you no
                    longer want to continue with our services and want to place
                    a cancellation request with immediate termination, your
                    hosting account will be suspended right away and will be
                    terminated within 48 hours
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Cancellation upon expiration-</b> If you place a
                    cancellation request to discontinue our services after your
                    subscription expires, your hosting account will be suspended
                    at the end of the subscription and will be terminated within
                    48 hours (after the expiration date).
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>You did not renew-</b> In case you fail to renew your
                    hosting account on the due date, your hosting account will
                    be suspended after 24 hrs and terminated within 48 hours
                    (after the expiration date).
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Violation of Terms of service-</b> If you violate our
                    terms of service during your subscription period at
                    ClubHosty, it will result in immediate account suspension
                    and termination. As soon as we've been notified about the
                    violation of service, we will take instant action.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Potential fraud-</b> We have an anti-fraud system that
                    monitors all the orders as soon as they are placed. During
                    such an occurrence, we will carry out a verification process
                    manually. In this process, if we ask for certain information
                    and it is not provided the account suspension and
                    termination will be done immediately.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>A Dispute or Chargeback-</b> During the violation of our
                    Terms of Service, we would initially suspend and give a 7
                    days timeframe to resolve the concern with ClubHosty before
                    the termination occurs. If still, unsolved termination of
                    your hosting account will take place
                  </p>
                  <i>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    <b>Note:</b> It is advised to maintain a backup copy of your
                    hosting account to avoid losing your data because of the
                    termination. All your files will be deleted from the server,
                    once your hosting account is terminated and ClubHosty shall
                    not be liable for the same.
                  </i>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Limitation of
                    Liability
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    To the maximum extent permitted by applicable law, and
                    without affecting your rights as a Consumer, you agree that
                    you will not under any circumstances, including negligence,
                    hold ClubHosty, its officers, directors, employees,
                    licensors, agents, subcontractors, and/or third-party
                    service providers liable for any direct or indirect damages
                    of any nature and type suffered by the
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Customer of third parties, including, but not limited to,
                    damages for loss of profits, cost savings, revenue,
                    business, data or use, or any other pecuniary loss that may
                    result from delays, malfunctions, suspension, and any other
                    interruption in the provision of the Service(s) due to
                    events beyond our reasonable control (for example force
                    majeure, third party conduct/acts, including ClubHosty's
                    licensors and suppliers, faults and malfunctions of the
                    machines, software, and other equipment, whether owned by us
                    or our licensors/suppliers; acts and/or omissions made by
                    Customers and in contrast with the obligations undertaken
                    under these TOS); data loss due to hardware or software
                    failure; any information, data, content in or accessed
                    through the Services; any action, information or instruction
                    provided as part of our technical support Services; your use
                    of the Service(s).
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    You agree that the foregoing limitations apply whether based
                    on warranty, contract or tort, or any other legal theory and
                    apply even if we have been advised of the possibility of
                    such damages. In no event, we will be liable to you in the
                    aggregate with respect to any and all breaches, defaults, or
                    claims of liability under these TOS or under any other
                    agreement or document for an amount greater than the fees
                    actually paid by you to us for the respective Service(s)
                    during the twelve-month period preceding a claim giving rise
                    to such liability. Some jurisdictions do not allow the
                    limitation or exclusion of liability for incidental or
                    consequential damages. You agree that in those
                    jurisdictions, our liability will be limited to the extent
                    permitted by law and your rights as a consumer will not be
                    affected.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> 404 Error Page
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If you haven't configured a 404 page, our default page for
                    the 404 error page will load when a visitor tries to access
                    a URL that has no information. By not creating a 404 page,
                    you hereby agree and authorize the Company’s placement of a
                    default 404 error page. This 404 error page of the company
                    may contain advertisements and other information about the
                    company and its services. As a company, we reserve the right
                    to withhold and collect all revenue generated from these
                    advertisements.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Price Change
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    The prices of our services may be changed from time to time
                    depending on our partner's/resources’ pricing. We have
                    authorized partners of multiple license providers. If
                    there's any change in their pricing structure, we will be
                    forced to increase the prices of our services to cover our
                    costs. You are required to review billing information from
                    time to time to avoid any surprise pricing. You will be
                    informed about the same 15 days prior to your next
                    billing/pricing.{" "}
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3>
                    <i className="fas fa-hand-point-right"></i> Third-Party
                    Beneficiaries
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Except as expressly given elsewhere in this Agreement,
                    nothing in this Agreement is intended, nor shall anything in
                    this Agreement be construed to grant any rights on any
                    individual other than the Parties hereunder and their
                    respective successors and approved assignments.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    Notwithstanding the above, the customer recognizes and
                    accepts that every provider of a third-party good or service
                    described in the contract definition as a third-party
                    beneficiary is the designated third-party beneficiary of the
                    requirements set out in this Agreement because they apply
                    exclusively to its goods or services and has the right to
                    explicitly implement the terms and conditions.
                  </p>
                </div>
              </div>
              <div className="section-heading">
                <div id="nav-id-7" className="pt-5">
                  <h3 id="migration">
                    <i className="fas fa-hand-point-right"></i> Migration Policy
                  </h3>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We do not take responsibility for the migration if the
                    previous host has added limitations to creating a backup of
                    files on their server.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We offer free website migration and up to 20
                    websites only. If either of the exceeds the limit, it
                    will be chargeable.
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If your website is configured on a custom script, then we
                    will only migrate your data to the ClubHosty servers. We do
                    not take responsibility for the configuration of data on
                    such scripts.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    As migration is a time taking process, there should be at
                    least 3 days remaining with your previous host to ensure
                    that the migration process can be carried out smoothly.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    If more than one website is to be migrated, the main website
                    (as per your request) will be migrated and made live within
                    4 hours. The remaining websites (up to 2) will be migrated
                    within the next business day.{" "}
                  </p>
                  <p>
                    <i
                      className="fa fa-solid fa-circle"
                      style={{ fontSize: "10px" }}
                    ></i>{" "}
                    We do not provide email migration services and henceforth,
                    do not take responsibility for the email migration as such.
                  </p>
                  <p className="p2">
                    <span className="s1"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
      </main>
    </>
  );
}

export default TermsAndConditions;
